export default "images/village-on-lake.jpg";